import { jsx, jsxs } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import './button.js';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import './radio-group.js';
import '@radix-ui/react-select';
import './time-input.js';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

function DetailGrid({ children, className }) {
    return (jsx("div", { className: cn('grid grid-cols-2 sm:grid-cols-3 gap-4', className), children: children }));
}
function DetailItem({ label, children, icon, className }) {
    if (icon) {
        return (jsxs("div", { className: cn('flex items-center gap-3', className), children: [jsx("div", { className: "text-zinc-700 flex-shrink-0", children: icon }), jsxs("div", { children: [jsx("p", { className: "text-xs font-medium uppercase tracking-wider text-muted-foreground", children: label }), jsx("p", { className: "text-sm font-medium mt-1", children: children })] })] }));
    }
    return (jsxs("div", { className: className, children: [jsx("p", { className: "text-xs font-medium uppercase tracking-wider text-muted-foreground", children: label }), jsx("p", { className: "text-sm font-medium mt-1", children: children })] }));
}

export { DetailGrid, DetailItem };
//# sourceMappingURL=DetailGrid.js.map
